import {Button, Popconfirm} from "antd";
import React from "react";
import Icons from "assets/icons";
import {TT_PHIEU_KHAM} from "types/enums";
import {CancelWhiteSVG, PrintColorWhiteSVG, SaveWhiteIconSVG} from "assets";
import {useAppSelector} from "redux/hooks";

const CompletedKCB = (handleFunc, loadingCompleteKCB) => {
  return (
    <Popconfirm
      onConfirm={handleFunc}
      title=""
      description="Chắc chắn hoàn thành phiếu khám tổng?"
      okText="Có"
      cancelText="Hủy"
      icon={null}
    >
      <Button
        className="btn-sub"
        htmlType="submit"
        loading={loadingCompleteKCB}
      >
        Hoàn thành KCB
      </Button>
    </Popconfirm>
  );
};
const CancelButton = (handleClick, trangThai: TT_PHIEU_KHAM) => {
  const listDisableTrangThai = [
    TT_PHIEU_KHAM.PKM,
    TT_PHIEU_KHAM.HT,
    TT_PHIEU_KHAM.H,
    TT_PHIEU_KHAM.X,
  ];
  const disabled = listDisableTrangThai.includes(trangThai);
  return (
    <Popconfirm
      onConfirm={handleClick}
      title=""
      description="Xác nhận hủy khám?"
      okText="Có"
      cancelText="Hủy"
    >
      <Button icon={<Icons.close />} type="primary" danger disabled={disabled}>
        Hủy khám
      </Button>
    </Popconfirm>
  );
};
const PostponeButton = (handleClick, trangThai: TT_PHIEU_KHAM) => {
  const listDisableTrangThai = [
    TT_PHIEU_KHAM.PKM,
    TT_PHIEU_KHAM.HT,
    TT_PHIEU_KHAM.H,
    TT_PHIEU_KHAM.X,
  ];
  const disabled = listDisableTrangThai.includes(trangThai);
  return (
    <Button
      icon={<Icons.pause />}
      type="primary"
      danger
      onClick={handleClick}
      disabled={disabled}
    >
      Tạm dừng{" "}
    </Button>
  );
};
const ReceiveButton = (handleClick, trangThai: TT_PHIEU_KHAM) => {
  const listDisableTrangThai = [TT_PHIEU_KHAM.PKM, TT_PHIEU_KHAM.X];
  const disabled = listDisableTrangThai.includes(trangThai);
  return (
    <Button
      // icon={<SaveWhiteIconSVG />}
      type="primary"
      onClick={handleClick}
      disabled={disabled}
    >
      Bệnh nhân tiếp theo
    </Button>
  );
};
const WaitingButton = (handleClick, trangThai: TT_PHIEU_KHAM) => {
  const listDisableTrangThai = [
    TT_PHIEU_KHAM.PKM,
    TT_PHIEU_KHAM.CTH,
    TT_PHIEU_KHAM.CKQ,
    TT_PHIEU_KHAM.H,
    TT_PHIEU_KHAM.X,
  ];
  const disabled = listDisableTrangThai.includes(trangThai);
  return (
    <Button
      icon={<Icons.save />}
      className="btn-sub"
      onClick={handleClick}
      disabled={disabled}
    >
      Chờ KQXN
    </Button>
  );
};
const CompleteButton = (handleClick, trangThai: TT_PHIEU_KHAM) => {
  const listDisableTrangThai = [
    TT_PHIEU_KHAM.PKM,
    TT_PHIEU_KHAM.CTH,
    TT_PHIEU_KHAM.H,
    TT_PHIEU_KHAM.X,
    TT_PHIEU_KHAM.HT,
  ];
  const disabled = listDisableTrangThai.includes(trangThai);
  return (
    <Button
      className="btn-sub"
      type="primary"
      icon={<SaveWhiteIconSVG />}
      onClick={handleClick}
      // disabled={disabled}
    >
      Hoàn thành
    </Button>
  );
};
const SavePrintButton = (
  handleClick,
  trangThai: TT_PHIEU_KHAM,
  loadingCompleteKCB
) => {
  const listDisableTrangThai = [
    TT_PHIEU_KHAM.PKM,
    TT_PHIEU_KHAM.H,
    TT_PHIEU_KHAM.X,
  ];
  const disabled = listDisableTrangThai.includes(trangThai);
  return (
    <Button
      icon={<Icons.printer />}
      type="primary"
      onClick={handleClick}
      disabled={disabled}
      loading={loadingCompleteKCB}
    >
      Lưu và in
    </Button>
  );
};
const SaveButton = (
  handleClick,
  trangThai: TT_PHIEU_KHAM,
  loadingCompleteKCB
) => {
  const listDisableTrangThai = [
    TT_PHIEU_KHAM.PKM,
    TT_PHIEU_KHAM.H,
    TT_PHIEU_KHAM.X,
  ];
  const disabled = listDisableTrangThai.includes(trangThai);
  return (
    <Button
      icon={<Icons.save />}
      type="primary"
      onClick={handleClick}
      disabled={disabled}
      loading={loadingCompleteKCB}
    >
      Lưu lại
    </Button>
  );
};
export {
  CompletedKCB,
  CancelButton,
  PostponeButton,
  ReceiveButton,
  WaitingButton,
  CompleteButton,
  SavePrintButton,
  SaveButton,
};
